export default "__VITE_ASSET__4495cb63__"